import React from 'react';
import clsx from 'clsx';
import {
  useFormContext,
} from 'react-hook-form';
import Controller from 'core/components/FormController';
import IconButton from '@mui/material/IconButton';
import ToolTip from 'core/components/Tooltip';
import {
  FieldComponentProps,
} from 'pages/Dashboard/pages/Charts/pages/Details/components/FieldsArrayWrapper';
import {
  DeleteIcon,
} from 'core/icons';
import Wrapper from 'pages/Dashboard/components/Input/Wrapper';
import PatientHistoryAutoComplete from 'views/EMR/components/PatientHistoryAutoComplete';

export default function AllergyInfo({
  index,
  onDelete,
  prefix,
  showLabel,
}: FieldComponentProps) {
  const dltBtnClasses = clsx('', { 'relative top-2.5': showLabel });
  const { control } = useFormContext();
  const key = `${prefix}.${index}`;

  return (
    <div className="flex items-center gap-4">
      <Controller
        name={`${key}.source`}
        rules={{ required: true }}
        control={control}
        render={({ field, fieldState: { invalid } }) => (
          <Wrapper
            id="nonDrugAllergySettings"
            label={showLabel ? 'Non-Drug Allergy' : ''}
            className="flex-1"
            error={invalid}
            showErrorText={false}
            required={showLabel}
          >
            <PatientHistoryAutoComplete
              {...field}
              id="nonDrugAllergySettings"
              keyName="source"
              placeholder="Non-Drug Allergies"
            />
          </Wrapper>
        )}
      />
      <Controller
        name={`${key}.reaction`}
        rules={{ required: true }}
        control={control}
        render={({ field, fieldState: { invalid } }) => (
          <Wrapper
            id="allergyReactionSettings"
            label={showLabel ? 'Reaction' : ''}
            className="w-[220px]"
            error={invalid}
            showErrorText={false}
            required={showLabel}
          >
            <PatientHistoryAutoComplete
              {...field}
              id="allergyReactionSettings"
              keyName="reaction"
              placeholder="Reaction"
              required
            />
          </Wrapper>
        )}
      />
      <ToolTip title="Delete">
        <span>
          <IconButton
            className={dltBtnClasses}
            onClick={() => { onDelete(index); }}
            color="error"
          >
            <DeleteIcon className="text-gray-400 !w-5 !h-5" />
          </IconButton>
        </span>
      </ToolTip>
    </div>
  );
}
